import {isEmpty} from "../containers/CreateAccount/utils";

export const generateAddress = (address1, address2, address3, city, state, zipcode) => {
	let address = '';

	if (address1) {
		address += address1;
	}
	if (address2) {
		address += ', ' + address2;
	}
	if (address3) {
		address += ', ' + address3;
	}
	if (city) {
		address += ', ' + city;
	}
	if (state) {
		address += ', ' + state;
	}
	if (zipcode) {
		address += ', ' + zipcode;
	}

	return address;
};

export const generateAddressNew = (address) => {
	if (typeof address === 'undefined') {
		return '';
	}

	let formatedAddress = '';

	if (address.address1) {
		formatedAddress += address.address1;
	}
	if (address.address2) {
		formatedAddress += ', ' + address.address2;
	}
	if (address.address3) {
		formatedAddress += ', ' + address.address3;
	}
	if (address.city) {
		formatedAddress += ', ' + address.city;
	}
	if (address.state && address.state.name) {
		formatedAddress += ', ' + address.state.name;
	}
	if (address.zipcode) {
		formatedAddress += ', ' + address.zipcode;
		if(address.zip4) {
			formatedAddress += '-' + address.zip4;
		}
	}

	return formatedAddress;
};

export const generateFormatedAddress = (address) => {
	if (typeof address === 'undefined') {
		return '';
	}

	let formatedAddress = '';

    if (address.address2) {
		formatedAddress += address.address2 + '/';
	}
	if (address.address1) {
		formatedAddress += address.address1;
	}
	if (address.address3) {
		formatedAddress += ', ' + address.address3;
	}
	if (address.city) {
		formatedAddress += ', ' + address.city;
	}
	if (address.state && address.state.name) {
		formatedAddress += ', ' + address.state.name;
	}
	if (address.zipcode) {
		formatedAddress += ', ' + address.zipcode;
	}

	return formatedAddress;
};

export const generateFullFormatedAddress = (address) => {
	if (isEmpty(address)) {
		return '';
	}

	let formatedAddress =
		{
			"fullAddress": generateFormatedAddress(address),
			"address1": address.address1,
			"address2": address.address2,
			"address3": address.address3,
			"city": address.city,
			"stateId": address.state? address.state.id: null,
			"state": address.state? address.state.name: null,
			"zip": address.zipcode,
			"zip4": address.zip4,
			"countryId": address.country? address.country.id: null,
			"country": address.country? address.country.name: null,
			"latitude": address.latitude,
			"longitude": address.longitude,
			"addressId": address.id
		};

	return formatedAddress;
};

export const getAddressWithUnit = (address, unit) => {
	let formatedAddress = '';
	if (unit) {
		formatedAddress = unit + '/' + address;
	} else {
		formatedAddress = address;
	}

	return formatedAddress;
};
